import { render, staticRenderFns } from "./RevisionDetail.vue?vue&type=template&id=23d4a5e8"
import script from "./RevisionDetail.vue?vue&type=script&lang=js"
export * from "./RevisionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports